// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: flex;
  height: calc(100vh - 100px);
  flex-direction: column;
  overflow: hidden;
  padding: 30px 50px 20px 50px;
  box-sizing: border-box;
  max-width: 1200px;
  margin: 0 auto;
}
:host .card {
  flex: 1;
  background-color: white;
  padding: 20px;
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  overflow: auto;
}

.brover-order-table {
  display: flex;
  flex-direction: column;
  flex: 1;
}
.brover-order-table__title {
  display: flex;
  flex-direction: row;
  border-bottom: 1px solid #a9a9a9;
  width: 100%;
}
.brover-order-table__title .column {
  display: flex;
  flex-direction: column;
  flex: 2;
  padding: 20px;
}
.brover-order-table__title .column:first-child {
  flex: 1;
  padding: 20px 20px 40px;
}
.brover-order-table__title .column input {
  display: flex;
  align-items: center;
  flex: 1;
  margin-top: 15px;
}
.brover-order-table__title .column button {
  padding: 5px;
  width: 50%;
  font-size: 18px;
  margin-top: 10px;
}
.brover-order-table__title .column span {
  display: block;
  font-size: 14px;
}
.brover-order-table__body {
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: auto;
}

.article-item {
  display: grid;
  grid-template-columns: 125px 125px 125px auto 90px 50px;
  padding: 15px 40px;
  border-bottom: 1px solid #d5d5d5;
  -webkit-user-select: auto;
          user-select: auto;
}
.article-item:hover {
  color: #d8b399;
  background-color: #fbf5ef;
}
.article-item__column {
  height: 75px;
  display: flex;
  align-items: center;
}
.article-item__column.amount {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: black;
}
.article-item__column.amount button:disabled span {
  color: #dadada !important;
}
.article-item__column.code {
  font-size: 14px;
  font-weight: 500;
}
.article-item__column.descr {
  font-size: 12px;
  padding-right: 30px;
}
.article-item__column.price {
  font-weight: 500;
}
.article-item__column:last-child {
  margin-right: 0;
  justify-content: center;
}
.article-item__column:last-child mat-icon {
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/app/modules/component/pages/quick-order/quick-order.component.sass"],"names":[],"mappings":"AAAC;EACC,aAAA;EACA,2BAAA;EACA,sBAAA;EACA,gBAAA;EACA,4BAAA;EACA,sBAAA;EACA,iBAAA;EACA,cAAA;AACF;AACE;EACE,OAAA;EACA,uBAAA;EACA,aAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,cAAA;AACJ;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,OAAA;AACF;AACE;EACE,aAAA;EACA,mBAAA;EACA,gCAAA;EACA,WAAA;AACJ;AACI;EACE,aAAA;EACA,sBAAA;EACA,OAAA;EACA,aAAA;AACN;AACM;EACE,OAAA;EACA,uBAAA;AACR;AAEM;EACE,aAAA;EACA,mBAAA;EACA,OAAA;EACA,gBAAA;AAAR;AAEM;EACE,YAAA;EACA,UAAA;EACA,eAAA;EACA,gBAAA;AAAR;AAEM;EACE,cAAA;EACA,eAAA;AAAR;AAEE;EACE,aAAA;EACA,sBAAA;EACA,OAAA;EACA,cAAA;AAAJ;;AAGA;EACE,aAAA;EACA,uDAAA;EACA,kBAAA;EACA,gCAAA;EACA,yBAAA;UAAA,iBAAA;AAAF;AAEE;EACE,cAAA;EACA,yBAAA;AAAJ;AAEE;EACE,YAAA;EACA,aAAA;EACA,mBAAA;AAAJ;AAEI;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;AAAN;AAGQ;EACE,yBAAA;AADV;AAGI;EACE,eAAA;EACA,gBAAA;AADN;AAGI;EACE,eAAA;EACA,mBAAA;AADN;AAGI;EACE,gBAAA;AADN;AAGI;EACE,eAAA;EACA,uBAAA;AADN;AAGM;EACE,eAAA;AADR","sourcesContent":["\\:host\n  display: flex\n  height: calc(100vh - 100px)\n  flex-direction: column\n  overflow: hidden\n  padding: 30px 50px 20px 50px\n  box-sizing: border-box\n  max-width: 1200px\n  margin: 0 auto\n\n  .card\n    flex: 1\n    background-color: white\n    padding: 20px\n    border-radius: 20px\n    display: flex\n    flex-direction: column\n    align-items: flex-end\n    overflow: auto\n\n\n.brover-order-table\n  display: flex\n  flex-direction: column\n  flex: 1\n\n  &__title\n    display: flex\n    flex-direction: row\n    border-bottom: 1px solid #a9a9a9\n    width: 100%\n\n    .column\n      display: flex\n      flex-direction: column\n      flex: 2\n      padding: 20px\n\n      &:first-child\n        flex: 1\n        padding: 20px 20px 40px\n\n\n      input\n        display: flex\n        align-items: center\n        flex: 1\n        margin-top: 15px\n\n      button\n        padding: 5px\n        width: 50%\n        font-size: 18px\n        margin-top: 10px\n\n      span\n        display: block\n        font-size: 14px\n\n  &__body\n    display: flex\n    flex-direction: column\n    flex: 1\n    overflow: auto\n\n\n.article-item\n  display: grid\n  grid-template-columns: 125px 125px 125px auto 90px 50px\n  padding: 15px 40px\n  border-bottom: 1px solid #d5d5d5\n  user-select: auto\n\n  &:hover\n    color: #d8b399\n    background-color: #fbf5ef\n\n  &__column\n    height: 75px\n    display: flex\n    align-items: center\n\n    &.amount\n      display: flex\n      flex-direction: column\n      justify-content: center\n      align-items: center\n      color: black\n\n      button:disabled\n        span\n          color: #dadada !important\n\n    &.code\n      font-size: 14px\n      font-weight: 500\n\n    &.descr\n      font-size: 12px\n      padding-right: 30px\n\n    &.price\n      font-weight: 500\n\n    &:last-child\n      margin-right: 0\n      justify-content: center\n\n      mat-icon\n        cursor: pointer\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
